import { render, staticRenderFns } from "./VendedorForm.vue?vue&type=template&id=b0fa489e&"
import script from "./VendedorForm.vue?vue&type=script&lang=js&"
export * from "./VendedorForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports